var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 5.9 8.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.9,4.4L1.4,8.9L0,7.4l3-3l-3-3L1.4,0L5.9,4.4L5.9,4.4L5.9,4.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkArrowIcon);
export default __webpack_public_path__ + "static/media/link-arrow-icon.9a824ebb0c79d90b0ce27bb73600cfad.svg";
export { ForwardRef as ReactComponent };